export default "/ezETH-WETH-BPT.e2d698d3732a7bdc94635db2499733a5.png";